import React, { Component } from "react";
import firebase from "../../utils/firebase";
import { UserContext } from "../../Context";
import { Link } from "react-router-dom";

import TrashIcon from "@atlaskit/icon/glyph/trash";

import MyTable from "../myTable/MyTable";

import { APPLICATION_STATUSES } from "../../utils/consts";

import "./myApplicationsTable.css";
export default class MyApplicationsTable extends Component {
  deleteInactiveApplication = application => {
    firebase
      .firestore()
      .collection("my")
      .doc(application.uid)
      .update({
        [`applications.${
          application.lid
        }`]: firebase.firestore.FieldValue.delete()
      })
      .then(() => {
        this.props.addFlag({
          appearance: 2,
          title: "Deleted"
        });
      })
      .catch(error => {
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again"
        });
        console.log(error);
      });
  };

  deleteActiveApplication = application => {
    const promises = [];
    if (application.status === APPLICATION_STATUSES._PENDING_SIGNATURE) {
      const updateEmailSignature = firebase
        .functions()
        .httpsCallable("updateSignatureEmail");
      const cancelEmailPromise = updateEmailSignature({
        uuid: application.uuid,
        method: "cancel_signrequest"
      })
        .then(result => console.log(result.data))
        .catch(error => console.log(error));
      promises.push(cancelEmailPromise);
    }
    const myPromise = firebase
      .firestore()
      .collection("my")
      .doc(application.uid)
      .update({
        [`applications.${
          application.lid
        }`]: firebase.firestore.FieldValue.delete()
      });
    promises.push(myPromise);
    const applicationPromise = firebase
      .firestore()
      .collection("application")
      .doc(application.uid)
      .delete();
    promises.push(applicationPromise);
    Promise.all(promises)
      .then(() => {
        this.props.addFlag({
          appearance: 2,
          title: "Successfull Deleted"
        });
      })
      .catch(error => {
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again"
        });
        console.log(error);
      });
  };

  render() {
    return (
      <div className="my-applications-table">
        <UserContext.Consumer>
          {userContext => {
            const my = userContext.my || {};
            const activeApplication = userContext.application || {};
            const applications = my.applications || {};
            return (
              <MyTable
                onSetPage={() => console.log("onSetPage")}
                caption="Applications"
                head={{
                  cells: [
                    {
                      key: "name",
                      content: (
                        <span className="my__table-header-cell">Name</span>
                      ),
                      isSortable: true,
                      width: 100,
                      shouldTruncate: true
                    },
                    {
                      key: "application",
                      content: (
                        <span className="my__table-header-cell">
                          Application
                        </span>
                      ),
                      isSortable: true,
                      width: 50,
                      shouldTruncate: true
                    },
                    {
                      key: "date",
                      content: (
                        <span className="my__table-header-cell">Date</span>
                      ),
                      isSortable: true,
                      width: 50,
                      shouldTruncate: true
                    },
                    {
                      key: "delete",
                      content: (
                        <span className="my__table-header-cell">Delete</span>
                      ),
                      width: 10,
                      shouldTruncate: true
                    }
                  ]
                }}
                rows={Object.keys(applications)
                  .map(lid => applications[lid])
                  .map((application, i) => {
                    return {
                      cells: [
                        {
                          key: `application-row__${i}_name`,
                          content: (
                            <Link
                              className="table-row-link"
                              to={`/listing/${application.lid}`}
                            >
                              {application.title}
                            </Link>
                          )
                        },
                        {
                          key: `application-row__${i}_application`,
                          content: (
                            <Link
                              className="table-row-link"
                              to={`/listing/${application.lid}`}
                            >
                              {application.lid === activeApplication.lid
                                ? "active"
                                : "inactive"}
                            </Link>
                          )
                        },
                        {
                          key: `application-row__${i}_date`,
                          content: (
                            <span>
                              {application.updated.toDate().toString()}
                            </span>
                          )
                        },
                        {
                          key: `application-row__${i}_delete`,
                          content: (
                            <TrashIcon
                              onClick={
                                application.lid === activeApplication.lid
                                  ? () =>
                                      this.deleteActiveApplication(
                                        activeApplication
                                      )
                                  : () =>
                                      this.deleteInactiveApplication(
                                        application
                                      )
                              }
                            />
                          )
                        }
                      ],
                      key: `application__row_${i}`
                    };
                  })}
                emptyView={<span>No Applications Submitted</span>}
                loading={userContext.myLoading}
              />
            );
          }}
        </UserContext.Consumer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/myApplicationsTable/MyApplicationsTable.js